import { service } from ".";

class CompanyApi {
  GetInformation() {
    return service.get(`footer-details`);
  }
}

export const companyApi = new CompanyApi();
